const euroFormatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

export const formatEuro = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  if (isNaN(num)) return value;
  return euroFormatter.format(num);
};
